import {
  GET_DEAL_FILE_LIST_DATA, GET_DEAL_FILE_LIST_DATA_SUCCESS,
} from '../../../constants/system/actions';

const dealFilesReducer: Reducer = (
  state: ReducerState = {
    isLoading: false,
  },
  action: ReduxAction,
): ReducerState => {
  switch (action.type) {
    case GET_DEAL_FILE_LIST_DATA:
      return {
        ...state,
        isLoading: !!action.payload && !!action.payload.page,
      };
    case GET_DEAL_FILE_LIST_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default dealFilesReducer;
